type SortByOption = {
  value: string;
  label: string;
};

/**
 * Default sort option (score1 - standard relevance)
 */
export const SORT_BY_DEFAULT: SortByOption = {
  value: "1",
  label: "Mais relevantes",
};

/**
 * Google campaign sort option (score2 - optimized for Google campaigns)
 * Internal use only, not visible in dropdown
 */
export const SORT_BY_GOOGLE_CAMPAIGN: SortByOption = {
  value: "9",
  label: "Campanha Google",
};

export abstract class SortByTransformer {
  static readonly defaultValue = SORT_BY_DEFAULT;

  static readonly googleCampaignValue = SORT_BY_GOOGLE_CAMPAIGN;

  // Options visible in the dropdown for user selection
  static readonly sortByList: SortByOption[] = [
    SORT_BY_DEFAULT,
    { value: "6", label: "Maior preço" },
    { value: "5", label: "Menor preço" },
    { value: "3", label: "Ano mais novo" },
    { value: "4", label: "Menor Km" },
  ];

  /**
   * Transforms a `sortBy` value into a corresponding label object from the predefined sorting options.
   *
   * @param {string} sortBy - The value representing the sort option.
   * @returns {SortByOption} - Returns the matched sorting object or the default value if no match.
   */
  static transform(sortBy: string): SortByOption {
    const { sortByList, defaultValue } = SortByTransformer;
    const value = sortBy ?? defaultValue.value;

    return sortByList.find((item) => item.value === value) ?? defaultValue;
  }
}
